import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { RoutingService } from '../routing.service';
export class BreadcrumbsComponent implements OnInit, OnDestroy {
public breadcrumbs;
private subscription: Subscription;
public homeIcon = 'fa fa-home';
/**
 * \@method constructor
 * @param {?} routingService
 * @param {?} changeDetectorRef
 */
constructor(
private routingService: RoutingService,
private changeDetectorRef: ChangeDetectorRef
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.subscription = this.routingService.onChange.subscribe(value => {
      this.breadcrumbs = value;
    });
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    this.subscription.unsubscribe();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-breadcrumbs',
  template: `
    <ol class="breadcrumb">
      <li *ngFor="let breadcrumb of breadcrumbs; let first = first; let last = last" [class.active]="last || !breadcrumb.url">
        <a *ngIf="breadcrumb.url" [routerLink]="breadcrumb.url">
          <i *ngIf="first" ngClass="{{homeIcon}}"></i>
          <ng-template [ngIf]="breadcrumb.data.breadcrumbs">{{breadcrumb.data.breadcrumbs}}</ng-template>
          <ng-template [ngIf]="!breadcrumb.data.breadcrumbs">{{breadcrumb.data.title}}</ng-template>
        </a>
        <ng-template [ngIf]="!breadcrumb.url">
          <i *ngIf="first" ngClass="{{homeIcon}}"></i>
          <ng-template [ngIf]="breadcrumb.data.breadcrumbs">{{breadcrumb.data.breadcrumbs}}</ng-template>
          <ng-template [ngIf]="!breadcrumb.data.breadcrumbs">{{breadcrumb.data.title}}</ng-template>
        </ng-template>
      </li>
    </ol>
  `,
  styles: [`
    .breadcrumb {
      float: right;
      background: transparent;
      margin-top: 0;
      margin-bottom: 0;
      font-size: 12px;
      padding: 7px 5px;
      position: absolute;
      top: 15px;
      right: 10px;
      border-radius: 2px;
    }

    .breadcrumb > li > a {
      color: #444;
      text-decoration: none;
      display: inline-block;
    }

    .breadcrumb > li > a > .fa,
    .breadcrumb > li > a > .glyphicon,
    .breadcrumb > li > a > .ion {
      margin-right: 5px;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RoutingService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'homeIcon': [{ type: Input },],
};
}

function BreadcrumbsComponent_tsickle_Closure_declarations() {
/** @type {?} */
BreadcrumbsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BreadcrumbsComponent.ctorParameters;
/** @type {?} */
BreadcrumbsComponent.propDecorators;
/** @type {?} */
BreadcrumbsComponent.prototype.breadcrumbs;
/** @type {?} */
BreadcrumbsComponent.prototype.subscription;
/** @type {?} */
BreadcrumbsComponent.prototype.homeIcon;
/** @type {?} */
BreadcrumbsComponent.prototype.routingService;
/** @type {?} */
BreadcrumbsComponent.prototype.changeDetectorRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
